import { inject, Injectable } from '@angular/core';
import { ApiVersion, StorageKeys } from '@core/constants';
import { BaseResponse } from '@core/models/base-response';
import { ClientCurrentResponse } from '@core/models/client';
import { UserModel } from '@core/models/user-model';
import { BaseService } from '@core/services/base.service';
import { StorageService } from '@core/services/storage/storage.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientService extends BaseService {
  readonly clientUrl = 'clients';
  private readonly storageService: StorageService = inject(StorageService);

  getCurrentClient(): Observable<BaseResponse<ClientCurrentResponse>> {
    return this.get<BaseResponse<ClientCurrentResponse>>(
      `${this.clientUrl}/current`,
      { apiVersion: ApiVersion.V1 }
    );
  }

  getInvitationsToken(clientId: number, userId: number) {
    return this.put<BaseResponse<any>>(
      `${this.clientUrl}/${clientId}/users/${userId}/invitations`,
      {},
      { apiVersion: ApiVersion.V1 }
    );
  }

  getPoaValidation(customerId: number): Observable<boolean> {
    return this.get<BaseResponse<boolean>>(
      `${this.clientUrl}/${customerId}/poas/validation`,
      { apiVersion: ApiVersion.V1, showErrorAlert: false }
    ).pipe(
      map((response: BaseResponse<boolean>) => response?.data === true),
      catchError(() => of(false))
    );
  }

  getCurrentClientPoaValidation(): Observable<boolean> {
    const customerId: number | undefined = this.storageService.get<UserModel>(
      StorageKeys.authUser
    )?.customerId;

    return customerId ? this.getPoaValidation(customerId) : of(false);
  }
}
